import { limit, QueryConstraint, Unsubscribe, where } from "firebase/firestore";
import randomString from "../../helpers/utils/functions/randomString";
import Toten from "../entities/toten.entity";
import FireTotenPipe from "../utils/pipe";
import EstablishmentDB from "./establishment";

class TotenDB extends FireTotenPipe {

  public static readonly colName = 'Totens'

  constructor(idEstab: string) {
    if(!idEstab)
      throw new Error('Informe o id do estabelecimento')
    super(`${EstablishmentDB.colName}/${idEstab}/${TotenDB.colName}`);
  }

  public async create(data: Toten): Promise<any> {
    const key = await this.generateKey();
    return this._create({
      ...data,
      key
    });
  }
  public update(id: string, data: Toten): Promise<any> {
    return this._update(id, data);
  }
  public delete(id: string): Promise<any> {
    return this._delete(id);
  }
  public getAll(...params: QueryConstraint[]): Promise<Toten[]> {
    return this._getAll<Toten>(...params);
  }
  public get(id: string): Promise<Toten> {
    return this._get(id);
  }
  public on(listener: (data: Toten[]) => void, ...params: QueryConstraint[]): Unsubscribe {
    return this._on(listener, ...params);
  }

  private async generateKey() {
    let key;
    let totens;
    do {
      key = randomString(8);
      totens = await this.getAll(
        where('key', '==', key),
        limit(1)
      )
    } while(totens.length !== 0);
    return key;
  }

}

export default TotenDB;